//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import visibilityMixin from '../common/visibility'
import popupMixin from '../common/popup'
const COMPONENT_NAME = 'cube-popup'
const EVENT_MASK_CLICK = 'mask-click'
export default {
  name: COMPONENT_NAME,
  mixins: [visibilityMixin, popupMixin],
  props: {
    type: {
      type: String,
      default: ''
    },
    mask: {
      type: Boolean,
      default: true
    },
    content: {
      type: String,
      default: ''
    },
    center: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: ''
    }
  },
  computed: {
    rootClass() {
      const cls = {
        'cube-popup_mask': this.mask
      }
      if (this.type) {
        cls[`cube-${this.type}`] = true
      }
      return cls
    },
    containerClass() {
      const center = this.center
      const position = this.position
      if (position) {
        return {
          [`cube-popup-${position}`]: true
        }
      }
      if (center) {
        return {
          'cube-popup-center': true
        }
      }
    }
  },
  methods: {
    maskClick(e) {
      this.$emit(EVENT_MASK_CLICK, e)
      if (this.maskClosable) {
        this.hide()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./packages/image-preview/src/popup/popup.vue